<template>
  <div>
    <div class="bootstrap-wrapper">
      <div class="container">
        <DirPath :path="[$t('reports')]" />
        <HeaderView v-bind="headerData" />
        <ReportsConfig />

        <div
          class="row my-5 text-center"
          v-if="reports.school && reports.course"
        >
          <div class="col-md-6" v-for="(item, i) in navigation" :key="i">
            <div>
              <div class="img-container">
                <router-link :to="item.link" v-slot="{ href, route, navigate }">
                  <img
                    :href="href"
                    @click="navigate"
                    :src="item.img"
                    class="h-200 pointer"
                  />
                </router-link>
              </div>
              <div class="title-container">
                <h4 class="text-barlow-condensed">{{ $t(item.title) }}</h4>
              </div>
            </div>
          </div>
        </div>

        <FooterComponent />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DirPath from "@/components/DirPath";
import FooterComponent from "@/components/Footer";
import ReportsConfig from "@/components/ReportsConfig";
import HeaderView from "@/components/HeaderView";

export default {
  name: "reports",
  components: {
    DirPath,
    FooterComponent,
    ReportsConfig,
    HeaderView,
  },
  data() {
    return {
      headerData: {
        title: "reports",
        body:
          "Selecciona qué información deseas ver, ya sea de forma grupal o individual",
      },
      navigation: [
        {
          title: "generalResults",
          text:
            "Obtén un análisis rápido y sencillo del progreso de tus estudiantes",
          img: require("@/assets/images/Componente 30 – 1.svg"),
          link: "/dashboard/analytics/reports/generalResults",
        },
        {
          title: "detailBySkill",
          text:
            "This card makes use of the card divider element. Lorem ipsum dolor sit amet.",
          img: require("@/assets/images/Componente 31 – 1.svg"),
          link: "/dashboard/analytics/reports/detailBySkill",
        },
        // {
        //   title: "lexileStandard",
        //   text:
        //     "This card makes use of the card divider element. Lorem ipsum dolor sit amet card makes use of the card divider. the card divider element. Lorem ipsum dolor amet card makes use of the card.",
        //   img: require("@/assets/images/Componente 32 – 1.svg"),
        //   link: "/dashboard/analytics/reports/lexileStandard",
        // },
        {
          title: "evolution",
          text:
            "This card makes use of the card divider element. Lorem ipsum dolor sit amet card makes use of the card divider. the card divider element. Lorem ipsum dolor amet card makes use of the card.",
          img: require("@/assets/images/Componente 33 – 1.svg"),
          link: "/dashboard/analytics/reports/evolution",
        },
        {
          title: "readingPlan",
          text:
            "This card makes use of the card divider element. Lorem ipsum dolor sit amet card makes use of the card divider. the card divider element. Lorem ipsum dolor amet card makes use of the card.",
          img: require("@/assets/images/Componente 34 – 1.svg"),
          link: "/dashboard/analytics/reports/readingPlan",
        },
        {
          title: "readingSpeed",
          text:
            "This card makes use of the card divider element. Lorem ipsum dolor sit amet card makes use of the card divider. the card divider element. Lorem ipsum dolor amet card makes use of the card.",
          img: require("@/assets/images/Componente 35 – 1.svg"),
          link: "/dashboard/analytics/reports/readingSpeed",
        },
        {
          title: "preferences",
          text:
            "This card makes use of the card divider element. Lorem ipsum dolor sit amet card makes use of the card divider. the card divider element. Lorem ipsum dolor amet card makes use of the card.",
          img: require("@/assets/images/Componente 36 – 1.svg"),
          link: "/dashboard/analytics/reports/preferences",
        },
        {
          title: "bestOfMonth",
          text:
            "This card makes use of the card divider element. Lorem ipsum dolor sit amet card makes use of the card divider. the card divider element. Lorem ipsum dolor amet card makes use of the card.",
          img: require("@/assets/images/Componente 37 – 1.svg"),
          link: "/dashboard/analytics/reports/bestOfMonth",
        },
      ],
    };
  },
  computed: {
    ...mapState(["reports", "dataUrl"]),
  },
};
</script>

<style lang="scss" scoped>
.img-container {
  height: 200px;
}

.title-container {
  height: 80px;
}
</style>
